var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Telegram",
    d: "M13.2427 0.0490367L0.950104 5.08282C0.942791 5.0858 0.935701 5.08936 0.928895 5.09348C0.829214 5.15323 0.133568 5.6035 1.11447 6.00721L1.12455 6.01113L4.05162 7.01183C4.07395 7.01951 4.0976 7.02193 4.12091 7.01892C4.14421 7.01592 4.16662 7.00756 4.18656 6.99444L11.4466 2.20108C11.4644 2.18932 11.4842 2.18141 11.5049 2.1778C11.6059 2.16012 11.8967 2.12702 11.7127 2.37418C11.5046 2.65472 6.54577 7.35718 5.9954 7.87871C5.96366 7.90886 5.94403 7.95071 5.94052 7.99569L5.70033 11.0256C5.7003 11.0564 5.70707 11.0869 5.72009 11.1145C5.73311 11.1421 5.75203 11.1661 5.77536 11.1846C5.80845 11.2067 5.84737 11.2169 5.88637 11.2138C5.92537 11.2106 5.96238 11.1943 5.99195 11.1672L7.73107 9.52241C7.75855 9.49643 7.79359 9.48119 7.83039 9.4792C7.86718 9.47721 7.90351 9.48859 7.93335 9.51147L10.9675 11.8428L10.9773 11.8498C11.0508 11.8978 11.844 12.3862 12.073 11.2954L14.1674 0.756846C14.1703 0.723462 14.1987 0.356512 13.9508 0.139652C13.6905 -0.0870266 13.322 0.0274349 13.2665 0.0397788C13.2584 0.0421864 13.2504 0.0452823 13.2427 0.0490367Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.3ce59aab1542b54a70d04f36acddbe1e.svg";
export { ForwardRef as ReactComponent };